/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".caption-cont[_ngcontent-%COMP%]   span[contenteditable=true][_ngcontent-%COMP%], .caption-cont2[_ngcontent-%COMP%]   span[contenteditable=true][_ngcontent-%COMP%], .caption-title[_ngcontent-%COMP%]   span[contenteditable=true][_ngcontent-%COMP%]{display:inline-block;min-width:200px;max-width:100%}#hero-form[_ngcontent-%COMP%]   .searchbar[_ngcontent-%COMP%]{width:calc(100% - 170px)}#hero-form[_ngcontent-%COMP%]  .key-options-wrapper{left:20px;right:20px;top:calc(100% + 1px)}"];
export { styles as styles };
